import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';
import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, LabelL } from '@sorare/core/src/atoms/typography';

import type { PremiumPackTitle_cardPack } from './__generated__/index.graphql.ts';

const Header = styled(Vertical)`
  width: 100%;
`;
type Props = {
  cardPack: PremiumPackTitle_cardPack;
};

export const PremiumPackTitle = ({ cardPack }: Props) => {
  return (
    <Header gap={0.5}>
      <SBHorizontal>
        <BrandM>
          <FormattedMessage defaultMessage="Elite Pack" />
        </BrandM>
      </SBHorizontal>
      <LabelL
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color':
              'linear-gradient(315deg, #868a8a 14.64%, #e8ecee 85.36%)',
          } as CSSProperties
        }
      >
        {cardPack.competition?.displayName}
      </LabelL>
    </Header>
  );
};

PremiumPackTitle.fragments = {
  cardPack: gql`
    fragment PremiumPackTitle_cardPack on CardPack {
      slug
      competition {
        slug
        displayName
      }
    }
  ` as TypedDocumentNode<PremiumPackTitle_cardPack>,
};
